
setTimeout(() => {
document.querySelectorAll(".tpo_option-type-selection")
  .forEach(btn => {
    btn.addEventListener("click", function () {
      const valor = this.innerText.trim();
      console.log("Seleccionó:", valor);

      if (valor === "Sí") {
       // console.log("Hacer algo si es SÍ");
        var cantidad_producto = 1;/*document.getElementsByClassName("cant_product")[0].value*/
         agregarComplemento("42157064257611", cantidad_producto);
      }

      if (valor === "No") {
        //console.log("Hacer algo si es NO");
         eliminarComplemento("42157064257611", "0");
      }
    });
  });

}, "1800");



function agregarComplemento(variantId, qty) {
 
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
       if(cart.items.length >= 0){
      //  console.log(variantId)
       
       
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: variantId,
                  quantity: qty
                })
              })
              .then(res => res.json())
              .then(data => {             
                //console.log("✅ Complemento agregado:", data);
                // aquí puedes actualizar el carrito lateral o redirigir
                // window.location.href = '/cart'; // si quieres mandar al carrito
              })
              .catch(err => console.error("❌ Error al agregar complemento:", err));
       }else{

       }
      

      })
    .catch(err => console.error("❌ Error:", err));
 
}

function eliminarComplemento(variantId, qty) {
 fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
       
      if (cart.items.length == 1 && cart.items[0].variant_id == variantId) {
       
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        })
        .then(r => r.json())
        .then(data => {

          console.log("🗑️ Complemento eliminado automáticamente:", data);
         // window.location.reload(false);


        });
      }
    })
    .catch(err => console.error("❌ Error:", err));
  /*
 // console.log(variantId)
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 0
    })
  })
  .then(res => res.json())
  .then(data => {
   // console.log("✅ Complemento agregado:", data);
    // aquí puedes actualizar el carrito lateral o redirigir
    // window.location.href = '/cart'; // si quieres mandar al carrito
  })
  .catch(err => console.error("❌ Error al agregar complemento:", err));*/
}
/**
 * Elimina la variante si es la única en el carrito
 * @param {Number} variantId - ID de la variante del complemento
 */
function eliminarSiEsUnico(variantId) {
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
       
      if (cart.items.length == 1 && cart.items[0].variant_id == variantId) {
       
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        })
        .then(r => r.json())
        .then(data => {

          //console.log("🗑️ Complemento eliminado automáticamente:", data);
          window.location.reload(false);


        });
      }
    })
    .catch(err => console.error("❌ Error:", err));
}

/**
 * Intercepta todas las llamadas fetch
 * y ejecuta la revisión después de un cambio de carrito
 */
(function() {
  const originalFetch = window.fetch;
  window.fetch = async function() {
    
    const response = await originalFetch.apply(this, arguments);
 
    // revisamos si la URL está relacionada al carrito
    const url = arguments[0];
  
    if (typeof url === "string" && (
        url.includes("/cart/change") 
    )) {
       
      // damos un pequeño delay para que Shopify actualice bien
      setTimeout(() => eliminarSiEsUnico("42157064257611"), 100); 
      // 👆 cambia por el variant_id de tu complemento
    }

    return response;
  };
})();